import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';

import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles({
  root: {
    width: 250
  },
});

export default function JobApplyButton(props) {
  const classes = useStyles();

  return (
    <>
      <div style={{marginBottom: 10}}>
        <Button disabled={props.applyInProgress} className={classes.root} onClick={props.onClick}  target='_blank' rel='noopener' color='secondary' variant="contained">Apply Now</Button>
      </div>
      { props.applyInProgress ? <CircularProgress /> : '' }
    </>
  );
}
